import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Skeleton,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  Modal,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import UseFetchGetAllEnquiries from "../../helper/UseFetchGetAllEnquiries";
import ChatCardQuery from "../Prescription/ChatCardQuery";
import { updateQueryStatus } from "../../connections/putApi";
import DoneIcon from "@mui/icons-material/Done";
import ChatIcon from "@mui/icons-material/Chat";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { menuItemStyle, textfieldText } from "../../style/AppointmentStyle";
import { showToast } from "../../utils/toastUtil";
import useDebounce from "../../hooks/UseDebounce";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { tabStyle } from "../../style/PatientReportStyle";
import SearchIcon from "@mui/icons-material/Search";
import { formattedDateWithoutBg } from "../../utils/constantFunctions";
import {
  setSearchPatient,
  setPrescriptionData,
  setPatientDetailsData,
  setAppointmentData,
} from "../../redux/slices/prescriptionSlice";
import UsePatientDetail from "../../helper/UsePatientDetail";
import UsePatientDetailPrescription from "../../helper/UsePatientDetailPrescription";
import UseFetchAppointmentDetailsPatient from "../../helper/UseFetchAppointmentDetailsPatient";
import { useDispatch } from "react-redux";
import { rotateSpinner } from "../../style/PatientDetailsStyle/index.js";
import loadingSpinner from "../../assets/loadingSpinner.svg";

const Enquiries = ({ onClose }) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [activeTab, setActiveTab] = useState("all");
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [appointmentsDate, setAppointmentsDate] = useState([]);

  const debounceQueryValue = useDebounce(search, 800);
  const {
    data: enquiryList,
    refetch,
    isLoading,
  } = UseFetchGetAllEnquiries(page, itemPerPage, activeTab, debounceQueryValue);

  const dispatch = useDispatch();

  // console.log(enquiryList?.payload?.queries, 'enquiryList')
  // Fetch patient details when a patient is selected
  const { data: patientDetails, isLoading: patientDetailsLoading } =
    UsePatientDetail(selectedPatientId);
  const { data: appointmentDetails, isLoading: appointmentDataLoading } =
    UseFetchAppointmentDetailsPatient(
      patientDetails?.payload?.appointments[0]?.id,
    );

  const {
    data: prescriptionDetails,
    isLoading: prescriptionDataLoading,
    status: prescriptionStatus,
  } = UsePatientDetailPrescription(
    (patientDetails?.payload?.appointments &&
      patientDetails?.payload?.appointments[0]?.prescription_id) ||
      (appointmentsDate?.length >= 2 && appointmentsDate[1]?.prescription_id),
  );

  const getStatusUI = (status) => {
    switch (status) {
      case "open":
        return {
          text: "Open",
          color: "#1976d2",
          bg: "#e3f2fd",
          Icon: ChatIcon,
        };

      case "resolved":
        return {
          text: "Resolved",
          color: "#4DD57B",
          bg: "#b4eec8",
          Icon: DoneIcon,
        };

      case "unresolved":
        return {
          text: "Closed",
          color: "#e53935",
          bg: "#ffebee",
          Icon: CloseIcon,
        };

      case "in_progress":
        return {
          text: "In Progress",
          color: "#fb8c00",
          bg: "#fff3e0",
          Icon: AutorenewIcon,
        };

      default:
        return {
          text: "Open",
          color: "#1976d2",
          bg: "#e3f2fd",
          Icon: ChatIcon,
        };
    }
  };

  const totalRecords = enquiryList?.meta?.total_count || 0;
  const totalPage = Math.ceil(totalRecords / itemPerPage);

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < totalPage) setPage((prev) => prev + 1);
  };

  useEffect(() => {
    setPage(1); // reset to first page when search or filter changes
  }, [debounceQueryValue, activeTab]);

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedQuery(null);
  };

  // ✅ One function to change status
  const handleChangeStatus = async (status, id) => {
    // console.log("Query ID:", selectedQuery?.id, "New Status:", status);
    // handleCloseMenu();
    const payload = {
      query: {
        status: status,
      },
    };
    try {
      const res = await updateQueryStatus(payload, id);

      if (res?.status?.status === "SUCCESS") {
        refetch();
        setSelectedQuery(null);
        setAnchorEl(null);
        showToast(`Status Update mark as ${status}`, "SUCCESS");
      } else {
        showToast(
          res?.status?.message || res?.status?.status,
          res?.status?.status,
        );
      }
      // console.log(res, 'res');
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelect = async (id, appointmentId) => {
    const now = new Date().toISOString();
    // ISO format: you can customize it

    // Get previous entries from localStorage
    //   let entries = JSON.parse(localStorage.getItem("cabinEntries")) || [];
    //   // Check if already exists
    //   if (entries?.id) {
    //     const newEntry = { id: id, entryTime: entries?.entryTime };
    //     localStorage.setItem("cabinEntries", JSON.stringify(newEntry));
    //     setCabinEntries(entries);
    //   } else {
    //     const newEntry = { id: id, entryTime: now };
    //     localStorage.setItem("cabinEntries", JSON.stringify(newEntry));
    //     setCabinEntries(entries);
    //   }

    // const alreadyExists = entries.some((entry) => entry.id === id);
    // if (!alreadyExists) {
    //   entries.push({ id: id, entryTime: now });
    //   // Update localStorage
    //   localStorage.setItem("cabinEntries", JSON.stringify(entries));
    //   // Optional: also update local state
    //   setCabinEntries(entries);
    // }

    setTimeout(() => {
      setSelectedPatientId(id);
    }, 0);
    dispatch(setSearchPatient([]));

    //   try {
    //     const resSummary = await summaryOfPatientRecording(appointmentId);
    //     // if (resSummary);
    //     if (resSummary?.status?.status === "SUCCESS") {
    //       handleOpenSummary();
    //       setVoiceSummary(resSummary);
    //     }
    //   } catch (error) {
    //     console.error(error, "error");
    //   }
  };

  useEffect(() => {
    if (patientDetails) {
      dispatch(setPatientDetailsData(patientDetails?.payload));
      // dispatch(setAppointmentData({}))
    }
    if (patientDetails?.payload?.appointments) {
      const dates = patientDetails?.payload?.appointments
        .filter(
          (appointment) =>
            ["completed", "paid"].includes(appointment?.status) ||
            appointment?.prescription_id,
        )
        .map((appointment) => ({
          date: new Date(appointment.visit_date).toDateString(),
          id: appointment.id, // Track the appointment ID for fetching details
          prescription_id: appointment?.prescription_id,
          appointmentStatus: appointment?.status,
        }));
      setAppointmentsDate(dates);
    } else {
      setAppointmentsDate([]);
    }
  }, [patientDetails, dispatch]);

  useEffect(() => {
    if (appointmentDetails) {
      dispatch(setAppointmentData(appointmentDetails));
      // dispatch(setAppointmentData({}));
      dispatch(setPrescriptionData([]));
    }
  }, [appointmentDetails, dispatch]);

  const [allDataLoading, setAllDataLoading] = useState(false);

  // Debounce effect to stabilize allDataLoading state
  useEffect(() => {
    if (patientDetailsLoading) {
      // console.log(patientDetailsLoading);
      setAllDataLoading(true); // Set to true immediately when patientDetailsLoading starts
    } else if (
      !patientDetailsLoading &&
      !appointmentDataLoading &&
      !prescriptionDataLoading
    ) {
      // Use a timeout to debounce the false state change
      const timer = setTimeout(() => {
        setAllDataLoading(false);
        // console.log("i am loader", "all api loader");
      }, 1000);

      return () => clearTimeout(timer); // Clear timeout if dependencies change before debounce ends
    }
  }, [patientDetailsLoading, appointmentDataLoading, prescriptionDataLoading]);

  useEffect(() => {
    if (prescriptionDetails && prescriptionStatus === "success") {
      // console.log(prescriptionDetails  ,'prescriptionDetails first ' , prescriptionDetails , prescriptionStatus)
      setTimeout(() => {
        dispatch(setPrescriptionData(prescriptionDetails));
      }, 550);
    }
  }, [prescriptionDetails]);

  return (
    <Box
      sx={{
        height: "98vh",
        display: "flex",
        flexDirection: "column",
        p: 1,
        overflowY: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.5,
          borderBottom: selectedQuery ? "1px solid #ccc" : "",
        }}
      >
        {selectedQuery ? (
          <>
            {/* 🔙 Back Icon */}
            <IconButton onClick={() => setSelectedQuery(null)}>
              <ArrowBackIcon />
            </IconButton>

            <Tooltip
              title="Click to load patient details"
              onClick={() => handleSelect(selectedQuery?.query_user?.id)}
            >
              <Typography
                fontWeight={700}
                sx={{ textAlign: "center", cursor: "pointer" }}
              >
                {selectedQuery?.query_by}
              </Typography>
            </Tooltip>

            <Box
              onClick={(e) => {
                setAnchorEl(e.currentTarget);
                setSelectedQuery(selectedQuery);
              }}
              sx={{
                px: 1.2,
                py: 0.4,
                borderRadius: "10px",
                border: `1px solid ${getStatusUI(selectedQuery.status).color}`,
                background: getStatusUI(selectedQuery.status).bg,
                cursor: "pointer",
              }}
            >
              <Typography fontSize={12}>
                {getStatusUI(selectedQuery.status).text}
              </Typography>
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
            >
              <MenuItem
                onClick={() => handleChangeStatus("open", selectedQuery?.id)}
                sx={menuItemStyle}
              >
                Open
              </MenuItem>
              <MenuItem
                onClick={() =>
                  handleChangeStatus("resolved", selectedQuery?.id)
                }
                sx={menuItemStyle}
              >
                Resolved
              </MenuItem>
              <MenuItem
                onClick={() =>
                  handleChangeStatus("in_progress", selectedQuery?.id)
                }
                sx={menuItemStyle}
              >
                In Progress
              </MenuItem>
            </Menu>
          </>
        ) : (
          <>
            <Box />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ForumOutlinedIcon sx={{ color: "neutral.teal" }} />
              <Typography variant="heading_Large" fontWeight={700}>
                Enquiries
              </Typography>
            </Box>
            <IconButton onClick={onClose}>
              <CloseIcon sx={{ color: "red" }} />
            </IconButton>
          </>
        )}
      </Box>

      {!selectedQuery && (
        <Box>
          <Tabs
            value={activeTab}
            onChange={(e, v) => setActiveTab(v)}
            variant="fullWidth"
            // sx={{ mb: 1 }}
            sx={{
              // mb: 1,
              alignItems: "center",
              "& .MuiTabs-flexContainer": {
                alignItems: "center",
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "neutral.teal",
                height: "2px",
              },
            }}
          >
            <Tab value="all" label="All" sx={tabStyle} />
            <Tab value="open" label="Open" sx={tabStyle} />
            <Tab value="in_progress" label="Progress" sx={tabStyle} />
            <Tab value="resolved" label="Resolved" sx={tabStyle} />
            {/* <Tab value="closed" label="Closed" sx={tabStyle} /> */}
          </Tabs>
        </Box>
      )}

      {!selectedQuery && (
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            // p: 1.5,
            m: 1.5,
            flexShrink: 0, // 🔑 fixed section
          }}
        >
          {/* Search Input */}
          <TextField
            placeholder="Search queries by patient name, mobile, or query title"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            size="small"
            fullWidth
            sx={textfieldText}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon sx={{ color: "gray" }} />
                </InputAdornment>
              ),
            }}
          />

          {/* Status Select */}
          {/* <FormControl size="small" sx={{ minWidth: 175 }}>
                    <Select
                        displayEmpty
                        value={statusFilter}
                        sx={selectField}
                        onChange={(e) => setStatusFilter(e.target.value)}
                    >
                        <MenuItem value="" sx={menuItemStyle}>All Status</MenuItem>
                        <MenuItem value="open" sx={menuItemStyle}>Open</MenuItem>
                        <MenuItem value="resolved" sx={menuItemStyle}>Resolved</MenuItem>
                        <MenuItem value="in_progress" sx={menuItemStyle}>In Progress</MenuItem>
                    </Select>
                </FormControl> */}
        </Box>
      )}

      <Box
        sx={{
          flex: 1, // 🔑 takes remaining height
          overflowY: "auto",
          scrollBehavior: "smooth",
          px: 1.5,
          display: "flex",
          flexDirection: "column",
          rowGap: 2,
          position: "relative",
          "&::-webkit-scrollbar": {
            width: "2px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "neutral.teal",
            borderRadius: "8px",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: 170,
            top: 30,
            // bottom: 30,
            width: "2px",
          }}
        />

        {isLoading && (
          <Box sx={{ p: 1 }}>
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                height={100}
                sx={{
                  borderRadius: "12px",
                  backgroundColor: "#e0e0e0",
                  mb: 2,
                }}
              />
            ))}
          </Box>
        )}

        {!selectedQuery &&
          enquiryList?.payload?.queries?.map((query) => {
            const { text, color, bg } = getStatusUI(query.status);

            return (
              <Box
                key={query.id}
                onClick={() => setSelectedQuery(query)}
                sx={{
                  backgroundColor: "neutral.blueShadeBg",
                  borderRadius: "12px",
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  gap: 0.5,
                }}
              >
                <Typography variant="heading2_14">
                  {query.query_by} ({query.patient_uid})
                </Typography>

                <Typography variant="title_medium">{query?.title}</Typography>

                <Typography variant="body_Grey1">
                  {query?.description}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body_Grey">
                    {formattedDateWithoutBg(query?.created_at)}
                  </Typography>

                  <Box
                    sx={{
                      px: 1,
                      py: 0.4,
                      borderRadius: "10px",
                      border: `1px solid ${color}`,
                      background: bg,
                      width: "fit-content",
                    }}
                  >
                    <Typography fontSize={12}>{text}</Typography>
                  </Box>
                </Box>
              </Box>
            );
          })}

        {selectedQuery && (
          <Box sx={{ flex: 1, overflowY: "auto" }}>
            <ChatCardQuery id={selectedQuery.id} />
          </Box>
        )}

        {enquiryList?.payload?.queries?.length === 0 && (
          <Box sx={{ margin: "auto" }}>
            <Typography>No queries found. </Typography>
          </Box>
        )}
      </Box>

      {!selectedQuery && (
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            p: 1,
            // pt: 0,
            alignItems: "center",
            justifyContent: "flex-start",
            flexShrink: 0, // 🔑 fixed footer
            borderTop: "1px solid #eee", // optional UX polish
          }}
        >
          <Typography>
            Displaying page {page} - {totalPage} of{" "}
            {enquiryList?.meta?.total_count} in total
          </Typography>

          {/* pagination buttons start */}
          <Box
            gap={1}
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Button
              onClick={handlePrevious}
              startIcon={<ArrowBackIcon sx={{ fontSize: "14px !important" }} />}
              sx={{
                fontSize: "12px",
                textTransform: "capitalize",
                border: "none",
                color: page === 1 ? "grey" : "neutral.teal",
              }}
            >
              Previous
            </Button>

            <Button
              sx={{
                fontSize: "12px",
                minWidth: "24px",
                minHeight: "24px",
                padding: "2px",
                borderRadius: "4px",
                border: "none",
              }}
            >
              {page}
            </Button>

            <Button
              onClick={handleNext}
              endIcon={
                <ArrowForwardIcon sx={{ fontSize: "14px !important" }} />
              }
              sx={{
                fontSize: "12px",
                textTransform: "capitalize",
                border: "none",
                color: page === totalPage ? "grey" : "neutral.teal",
              }}
            >
              Next
            </Button>
          </Box>
          {/* pagination buttons end */}
        </Box>
      )}

      <Modal
        open={allDataLoading}
        //onClose={}
        sx={{
          border: "none",
          position: "absolute",
          top: "40%",
          left: "40%",
          // border:'1px solid transparent',
        }}
      >
        <Box
          sx={{
            animation: `${rotateSpinner} 1s linear infinite`,
            width: "50px",
            border: "none !important",
            outline: "none !important",
          }}
        >
          <img
            src={loadingSpinner}
            alt=""
            style={{
              width: "50px",
              height: "50px",
              border: "none !important",
              outline: "none !important",
            }}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default Enquiries;
